import { useState } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import Text16 from '@sdk/components/ui/typography/Text16';
import Button from '@sdk/components/ui/buttons/Button';
import gettext from '@sdk/lang/gettext';
import useAuth from '@sdk/authentication/useAuth';
import useConfig from '@sdk/config/useConfig';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import customerReviews from '../constants/customerReviews';
import StarSvg from '../../assets/svg/Icons/16/star.svg';

const CustomerReviewsContent = styled(Column)`
  align-items: center;
  background-color: ${({ theme }): string => theme.colors.bodyBg};
  padding: 40px 0;
`;

const ButtonContainer = styled(Row)`
  width: 40%;
`;

type Props = {
  purchasePremium: () => void;
};

export const CustomerReviews: React.FC<React.PropsWithChildren<Props>> = ({ purchasePremium }) => {
  const { currentUser } = useAuth();
  const { TOAST_SALES_URL } = useConfig();

  const [review] = useState(() => {
    const idx = Math.floor(Math.random() * customerReviews.length);
    return customerReviews[idx];
  });

  const onToastUpgrade = () => {
    window.open(TOAST_SALES_URL, '_blank');
  };

  return (
    <CustomerReviewsContent>
      <Row>
        <StarSvg />
        <StarSvg />
        <StarSvg />
        <StarSvg />
        <StarSvg />
      </Row>
      <Row pTop={20} pBottom={10}>
        <Text16 bold themeColor={ThemeColorType.gray} textAlign="center">
          {review.content}
        </Text16>
      </Row>

      <Text16 themeColor={ThemeColorType.gray}>- {review.author}</Text16>

      <ButtonContainer pTop={30}>
        {currentUser.org.isToastSignup ? (
          <Button onClick={onToastUpgrade} buttonType={ButtonType.primary}>
            {gettext('Visit Toast Shop to upgrade')}
          </Button>
        ) : (
          <Button onClick={purchasePremium} buttonType={ButtonType.primary}>
            {gettext('Purchase premium')}
          </Button>
        )}
      </ButtonContainer>
    </CustomerReviewsContent>
  );
};
